var _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftMarketplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 118,
    viewBox: "0 0 112 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2773,
    y: 15.4285,
    width: 73.9055,
    height: 73.8073,
    rx: 4,
    fill: "url(#paint0_linear_2_4827)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_2_4827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8512 13.2154C10.0155 19.3804 7.04639 32.3403 13.2206 42.1624C19.3949 51.9845 32.369 54.9492 42.2047 48.7842C52.0404 42.6192 55.0095 29.6593 48.8353 19.8372C42.661 10.0156 29.6869 7.05092 19.8512 13.2154Z",
    fill: "url(#paint1_radial_2_4827)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 71H103.819L111 79.2L85.5 118L60 79.2L79.6248 71.6864L85.5 71Z",
    fill: "url(#paint2_linear_2_4827)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2033 118L75 87H95L85.2033 118Z",
    fill: "url(#paint3_linear_2_4827)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3328 87.0001L111 79.1969L85.5 40.0001L60 79.1969L75.2592 87.0001H95.3328Z",
    fill: "url(#paint4_linear_2_4827)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2033 40.0001L95 87.0001H75L85.2033 40.0001Z",
    fill: "url(#paint5_linear_2_4827)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0795 33.5C60.0795 32.1193 46.8543 31 30.5402 31C14.2262 31 1.00098 32.1193 1.00098 33.5",
    stroke: "url(#paint6_linear_2_4827)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4827",
    x: 17.2773,
    y: 9.42847,
    width: 93.9053,
    height: 93.8073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4827",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_2_4827",
    x: 0,
    y: 0,
    width: 62.0557,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4827",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_2_4827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4827",
    x1: 105.248,
    y1: 126.139,
    x2: -14.6244,
    y2: -58.5245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_4827",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9439 49.2) rotate(-58.1573) scale(47.1303 47.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF89E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#92D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991368,
    stopColor: "#89A7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_4827",
    x1: 85.4999,
    y1: 70.9906,
    x2: 85.4999,
    y2: 130.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_4827",
    x1: 85.0001,
    y1: 131.674,
    x2: 85.0001,
    y2: 87.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17DAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_4827",
    x1: 85.4999,
    y1: 102.964,
    x2: 85.4999,
    y2: 27.4077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B86E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_4827",
    x1: 85.0003,
    y1: 19.6759,
    x2: 85.0003,
    y2: 79.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B86E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_4827",
    x1: -7.51033,
    y1: 34,
    x2: 94.6246,
    y2: 28.4854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.557292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4DF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftMarketplaceIcon);
export default __webpack_public_path__ + "static/media/nft-marketplace-icon.7f53c8185a6b71de3167b0f5aaaaeb0c.svg";
export { ForwardRef as ReactComponent };